import React from "react";
import { Flame, Clock3, CheckCircle2, CloudSun } from "lucide-react";

function fmtMins(mins) {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}

export default function WeekStrip({ stats }) {
  const total = stats?.total_minutes || 0;
  const blocks = stats?.blocks_completed || 0;
  const streak = stats?.streak_days || 0;
  const graceInEffect = !!stats?.streak_includes_grace_day;

  const items = [
    { icon: Clock3, label: "this week", value: fmtMins(total), testid: "week-total-minutes" },
    { icon: CheckCircle2, label: "blocks done", value: `${blocks}`, testid: "week-blocks-done" },
    {
      icon: Flame,
      label: "streak",
      value: `${streak} ${streak === 1 ? "day" : "days"}`,
      testid: "week-streak",
      badge: graceInEffect ? "grace day used" : null,
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-3 sm:gap-4 mt-6 mb-8" data-testid="week-strip">
      {items.map(({ icon: Icon, label, value, testid, badge }, i) => (
        <div
          key={label}
          className={`card-soft-2 px-4 sm:px-5 py-4 flex items-center gap-3 fade-up delay-${i + 1}`}
          data-testid={testid}
        >
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
            style={{ background: "color-mix(in oklab, var(--primary-soft) 60%, transparent)" }}
          >
            <Icon size={16} strokeWidth={1.5} style={{ color: "var(--primary)" }} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-xs uppercase tracking-wider text-muted truncate">{label}</div>
            <div className="font-display text-2xl leading-tight" style={{ color: "var(--text)" }}>{value}</div>
            {badge && (
              <div
                className="mt-1 inline-flex items-center gap-1 text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full"
                style={{
                  background: "color-mix(in oklab, var(--primary-soft) 55%, transparent)",
                  color: "var(--primary)",
                }}
                data-testid="grace-day-badge"
                title="Every long streak deserves one gentle day off a month. This one's on the app."
              >
                <CloudSun size={11} strokeWidth={1.75} />
                {badge}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
